import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common components
import { Form, Button, TextInput } from "src/Components";
// Types
import { IDeltaConfig } from "src/Interfaces/automaticMarketMaking";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Requests
import {
  getDeltaConfig,
  setDeltaonfig,
} from "src/Requests/automaticMarketMaking";

interface Props {
  onSuccess: () => void;
  onClose: () => void;
}
const DeltaConfigModal: React.FC<Props> = (props) => {
  // local store
  const [config, setConfig] = React.useState({} as IDeltaConfig);

  React.useEffect(() => {
    getDeltaConfig()
      .then((res) => {
        setConfig(res);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setConfig({ ...config, [name]: value });
  };

  const clickHandler = () => {
    setDeltaonfig(config)
      .then((resp) => {
        toast.success(resp.msg);
        props.onSuccess();
        props.onClose();
      })
      .catch(packetErrorHandler);
  };

  return (
    <>
      <Form className="!w-80 gap-3 py-8 px-2 !mx-auto">
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72">حدبالای ضریب</span>
          <TextInput
            label=""
            name="upperboundfactor"
            onChange={changeHandler}
            value={config?.upperboundfactor?.toString() || ""}
            kind="percent"
            extraLabel
          />
        </div>
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72"> حد پایین ضریب</span>
          <TextInput
            label=""
            name="lowerboundfactor"
            onChange={changeHandler}
            value={config?.lowerboundfactor?.toString() || ""}
            kind="percent"
            extraLabel
          />
        </div>
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72">حداکثر درصد دلتا</span>
          <TextInput
            label=""
            name="maxDeltaPercentage"
            onChange={changeHandler}
            value={config?.maxDeltaPercentage?.toString() || ""}
            kind="negativeDecimalNumbers"
            extraLabel
          />
        </div>
        <div className="flex w-full items-center ">
          <span className="text-sm text-gray-500 w-72">حداقل درصد دلتا</span>
          <TextInput
            label=""
            name="minDeltaPercentage"
            onChange={changeHandler}
            value={config?.minDeltaPercentage?.toString() || ""}
            kind="negativeDecimalNumbers"
            extraLabel
          />
        </div>
      </Form>
      <div className="mt-6 mx-10">
        <Button text="ثبت" onClick={clickHandler} variant="contained" />
      </div>
    </>
  );
};

export default DeltaConfigModal;
